import { createSlice } from '@reduxjs/toolkit';

import { getLivePatternsFulfilled } from '../../api/pattern-live.api';
import type { PatternLiveSchema } from '../types/pattern-live.schema';

const initialState: PatternLiveSchema = {
    lastUpdated: null,
    pinnedUniqueId: null,
};

const patternLiveSlice = createSlice({
    name: 'patternLive',
    initialState,
    reducers: {
        setPinnedUniqueId: (state, action: { payload: string | null }) => {
            state.pinnedUniqueId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(getLivePatternsFulfilled, (state) => {
            state.lastUpdated = Date.now();
        });
    },
});

export const { setPinnedUniqueId } = patternLiveSlice.actions;
export const { reducer: patternLiveReducer } = patternLiveSlice;
